'use client';
import { useEffect, useState } from 'react';

import TileData from '../../components/TileData';
import { fetchUser } from '../../lib/user';

import { Checkbox } from '@components/Form';
import { useUserStore } from '@utils/user';
import { User } from 'types/user';

interface Props {
  labels: {
    title: string;
    notifications: {
      [key: string]: string;
    };
  };
}

export default function Tile({ labels }: Props) {
  const [user, setUser] = useState<User | null>(null);
  const userStore = useUserStore();

  useEffect(() => {
    if (!userStore.isReady || !userStore.isLoggedIn || !userStore.accessToken) {
      return;
    }

    fetchUser(setUser, userStore.accessToken);
  }, [userStore.isReady]);

  const renderAnswers = () =>
    Object.keys(labels.notifications).map((item) => (
      <div key={item} className="mb-2">
        <Checkbox
          defaultChecked={user?.[item]}
          checked={user?.[item]}
          onChange={async () => {
            await fetch(`${process.env.NEXT_PUBLIC_API}/users/profile/edit`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userStore.accessToken}`,
              },
              body: JSON.stringify({
                [item]: !user?.[item],
              }),
            });
            userStore.fetchUser();
          }}
          label={labels.notifications[item]}
        />
      </div>
    ));

  return (
    <TileData className="col-span-2" title={labels.title}>
      {renderAnswers()}
    </TileData>
  );
}
